<template>
  <aside class="sidebar menu is-hidden-touch">
    <p class="menu-label">Mi cuenta</p>
    <ul class="menu-list">
      <li><router-link :to="{ name: 'home.perfil' }">Perfil</router-link></li>
      <li>
        <router-link :to="{ name: 'home.cambiar-clave' }">Cambiar clave</router-link>
      </li>
    </ul>

    <p  class="menu-label">FILES</p>

    <div>
      <p v-if="isAccess('FBA') || isAccess('FBC') " class="menu-label">&nbsp;&nbsp; Consulta</p>
      <ul class="menu-list">
        <li>
          <router-link v-if="isAccess('FBA')" :to="{ name: 'home.consulta' }">Búsqueda por Archivo</router-link>
        </li>
      </ul>

      <ul class="menu-list">
        <li>
          <router-link v-if="isAccess('FBC')" :to="{ name: 'home.consultaPorCaja' }">Búsqueda por Caja</router-link>
        </li>
      </ul>

      <p v-if="isAccess('FP') || isAccess('FR') || isAccess('FD') || isAccess('FC') " class="menu-label">&nbsp;&nbsp;Solicitudes</p>
      <ul class="menu-list">
        <li>
          <router-link v-if="isAccess('FP')"  :to="{ name: 'home.pedidos' }">Pedidos</router-link>
        </li>
        <li>
          <router-link v-if="isAccess('FR')" :to="{ name: 'home.recojos' }">Recojos</router-link>
        </li>
        <li>
          <router-link v-if="isAccess('FD')" :to="{ name: 'home.digitalizacion' }">Digitalización</router-link>
        </li>
        <li>
          <router-link v-if="isAccess('FC')" :to="{ name: 'home.inquiries' }">Consultas</router-link>
        </li>
      </ul>

      <p v-if="isAccess('FRP') || isAccess('FRR') || isAccess('FRD') || isAccess('FRA') " class="menu-label">&nbsp;&nbsp;Reportes</p>
      <ul class="menu-list">
        <li>
          <router-link v-if="isAccess('FRP')" :to="{ name: 'home.reporte-pedidos' }">Reporte de pedidos</router-link>
        </li>
        <li>
          <router-link v-if="isAccess('FRR')" :to="{ name: 'home.reporte-recojos' }">Reporte de recojos</router-link>
        </li>
        <li>
          <router-link v-if="isAccess('FRD')" :to="{ name: 'home.reporte-digitalizacion' }">Reporte de digitalizacion</router-link>
        </li>
        <li>
          <router-link v-if="isAccess('FRA')" :to="{ name: 'home.reporte-files' }">Reporte de archivos</router-link>
        </li>
      </ul>
    </div>

    <p class="menu-label">MEDIOS</p>

    <div>
      <p v-if="isAccess('MBM') || isAccess('MBC') " class="menu-label">&nbsp;&nbsp; Consulta</p>
      <ul class="menu-list">
        <li>
          <router-link v-if="isAccess('MBM')" :to="{ name: 'home.consultaMedios' }">Búsqueda de Medios</router-link>
        </li>
      </ul>

      <ul class="menu-list">
        <li>
          <router-link v-if="isAccess('MBC')" :to="{ name: 'home.consultaPorCajaMedios' }">Búsqueda de Caja Medios</router-link>
        </li>
      </ul>

      <p v-if="isAccess('MP') || isAccess('MR')" class="menu-label">&nbsp;&nbsp;Solicitudes</p>
      <ul class="menu-list">
        <li>
          <router-link v-if="isAccess('MP')" :to="{ name: 'home.pedido-medios' }">Pedidos</router-link>
        </li>
      </ul>

      <ul class="menu-list">
        <li>
          <router-link v-if="isAccess('MR')" :to="{ name: 'home.recojo-medios' }">Recojos</router-link>
        </li>
      </ul>

     <p v-if="isAccess('MRR')" class="menu-label">&nbsp;&nbsp;Reportes</p>

      <ul class="menu-list">
        <li>
          <router-link v-if="isAccess('MRP')" :to="{ name: 'home.reporte-pedidos-medios' }">Reporte Pedidos</router-link>
        </li>

      </ul>
      <ul class="menu-list">
        <li>
          <router-link v-if="isAccess('MRR')" :to="{ name: 'home.reporte-recojos-medios' }">Reporte Recojos</router-link>
        </li>

      </ul>
      <ul class="menu-list">
        <li>
          <router-link v-if="isAccess('MRR')" :to="{ name: 'home.reporte-cajas-medios' }">Reporte Cajas</router-link>
        </li>

      </ul>


      <!-- <p class="menu-label">&nbsp;&nbsp;Solicitudes</p>
    <ul class="menu-list">
      <li><router-link :to="{ name: 'home.pedidos' }">Pedidos</router-link></li>
      <li><router-link :to="{ name: 'home.recojos' }">Recojos</router-link></li>
    </ul>


    <p class="menu-label">&nbsp;&nbsp;Reportes</p>
    <ul class="menu-list">
      <li>
        <router-link :to="{ name: 'home.reporte-pedidos' }">Reporte de pedidos</router-link>
      </li>
      <li>
        <router-link :to="{ name: 'home.reporte-recojos' }">Reporte de recojos</router-link>
      </li>
      <li>
        <router-link :to="{ name: 'home.reporte-digitalizacion' }">Reporte de digitalizacion</router-link>
      </li>
      <li>
        <router-link :to="{ name: 'home.reporte-files' }">Reporte de archivos</router-link>
      </li>
    </ul> -->
     <p class="menu-label">MATERIALES</p>
    </div>



    <p class="menu-label">PLANOS</p>

    <div>
      <p v-if="isAccess('PBP') || isAccess('PBC') " class="menu-label">&nbsp;&nbsp; Consulta</p>
      <ul class="menu-list">
        <li>
          <router-link v-if="isAccess('PBP')" :to="{ name: 'home.consultaPlanos' }">Búsqueda de Planos</router-link>
        </li>
      </ul>

      <ul class="menu-list">
        <li>
          <router-link v-if="isAccess('PBC')" :to="{ name: 'home.consultaPorCajaPlanos' }">Búsqueda de Caja Planos</router-link>
        </li>
      </ul>

      <p v-if="isAccess('PP') || isAccess('PR')" class="menu-label">&nbsp;&nbsp;Solicitudes</p>
      <ul class="menu-list">
        <li>
          <router-link v-if="isAccess('PP')" :to="{ name: 'home.pedido-planos' }">Pedidos</router-link>
        </li>
      </ul>

      <ul class="menu-list">
        <li>
          <router-link v-if="isAccess('PR')" :to="{ name: 'home.recojo-planos' }">Recojos</router-link>
        </li>
      </ul>

     <p v-if="isAccess('PRR')" class="menu-label">&nbsp;&nbsp;Reportes</p>

      <ul class="menu-list">
        <li>
          <router-link v-if="isAccess('PRP')" :to="{ name: 'home.reporte-pedidos-planos' }">Reporte Pedidos</router-link>
        </li>

      </ul>
      <ul class="menu-list">
        <li>
          <router-link v-if="isAccess('PRR')" :to="{ name: 'home.reporte-recojos-planos' }">Reporte Recojos</router-link>
        </li>

      </ul>
    </div>





    <p class="menu-label">MUESTRAS</p>

    <div>
      <p v-if="isAccess('RBR') || isAccess('RBC') " class="menu-label">&nbsp;&nbsp; Consulta</p>
      <ul class="menu-list">
        <li>
          <router-link v-if="isAccess('RBR')" :to="{ name: 'home.consultaMuestras' }">Búsqueda de Muestras</router-link>
        </li>
      </ul>

      <ul class="menu-list">
        <li>
          <router-link v-if="isAccess('RBC')" :to="{ name: 'home.consultaPorCajaMuestras' }">Búsqueda de Caja Muestras</router-link>
        </li>
      </ul>

      <p v-if="isAccess('RP') || isAccess('RR')" class="menu-label">&nbsp;&nbsp;Solicitudes</p>
      <ul class="menu-list">
        <li>
          <router-link v-if="isAccess('RP')" :to="{ name: 'home.pedido-muestras' }">Pedidos</router-link>
        </li>
      </ul>

      <ul class="menu-list">
        <li>
          <router-link v-if="isAccess('RR')" :to="{ name: 'home.recojo-muestras' }">Recojos</router-link>
        </li>
      </ul>

     <p v-if="isAccess('RRR')" class="menu-label">&nbsp;&nbsp;Reportes</p>

      <ul class="menu-list">
        <li>
          <router-link v-if="isAccess('RRP')" :to="{ name: 'home.reporte-pedidos-muestras' }">Reporte Pedidos</router-link>
        </li>

      </ul>
      <ul class="menu-list">
        <li>
          <router-link v-if="isAccess('RRR')" :to="{ name: 'home.reporte-recojos-muestras' }">Reporte Recojos</router-link>
        </li>

      </ul>
    </div>


      <p v-if="isAccess('SM')" class="menu-label">&nbsp;&nbsp; Abastecimiento</p>
      <ul class="menu-list">
        <li>
          <router-link v-if="isAccess('SM')" :to="{ name: 'home.solicitud-materiales' }">Solicitud de Materiales</router-link>
        </li>
      </ul>

    <div>

    </div>
  </aside>
</template>
<script>
import {mapActions, mapMutations, mapGetters} from 'vuex'
import Util from "../util";
export default {
  data() {
    return {};
  },
  computed: {
    ...mapGetters({ getClient: "auth/getClient" }),
  },
  methods: {
    isAccess(access) {
      return this.getClient.access.find((a) => a === access);
    },
  },
};
</script>


<style scoped lang="scss">
.sidebar {
  min-width: 16rem;
  margin-right: 3rem;
  padding-right: 0.5rem;
  position: -webkit-sticky;
  position: sticky;
  top: 1rem;
  overflow: auto;
  max-height: calc(100vh - 2rem);
}
</style>



// WEBPACK FOOTER //
// src/pages/Sidebar.vue